
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/zakwaterowanie",
      function () {
        return require("private-next-pages/[region]/[resort]/zakwaterowanie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/zakwaterowanie"])
      });
    }
  